export default {
    blog:5,
    recruiment: 5
};